// We create Redux store directly, instead of using any extra dependencies.
import { legacy_createStore as createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import createReducer from './reducers';
import * as analytics from './analytics/analytics';
import appSettings from './config/settings';

/** Opt-in for staging / debug images: connect Redux DevTools in the browser when the extension is installed. */
const parseReactAppBoolFlag = v => {
  if (v === true || v === 1) {
    return true;
  }
  if (typeof v === 'string') {
    const s = v.trim().toLowerCase();
    return s === 'true' || s === '1' || s === 'yes';
  }
  return false;
};

/**
 * Create a new store with the given initial state. Adds Redux
 * middleware and enhancers.
 */
export default function configureStore(initialState = {}, sdk = null, analyticsHandlers = []) {
  const middlewares = [thunk.withExtraArgument(sdk), analytics.createMiddleware(analyticsHandlers)];

  const reduxDevtoolsCompose =
    typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
  const useReduxDevtools =
    !!reduxDevtoolsCompose &&
    (appSettings.dev || parseReactAppBoolFlag(process.env.REACT_APP_ENABLE_REDUX_DEVTOOLS));

  const composeEnhancers = useReduxDevtools ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : compose;

  const enhancer = composeEnhancers(applyMiddleware(...middlewares));

  const store = createStore(createReducer(), initialState, enhancer);

  return store;
}
